exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading-text {\n  color: #06263e;\n  font-size: 1rem;\n  font-weight: 600;\n  letter-spacing: 0.07rem;\n}\n", ""]);

// exports
